module.exports = __webpack_public_path__ + "static/media/video-icon5.5a7d25f3.svg";